// Pure helpers of the /ancestry landing page (docs/ancestry-landing.md): the Christmas
// order-by dates shown in the holiday strip and the deadlines section. Same season window and
// dates as /shipping, so the page shows nothing seasonal for a year without configured dates.

import { holidayOrderBy, holidaySeasonYear } from 'ecommerce/lib/shippingSchedule';

// Family Flip ships like the standard products (prints, calendars), not like the posters.
export const DEADLINE_PRODUCTS = [
  { id: 'book', name: 'Ancestry Book', holidayGroup: 'familyHistoryBooks' },
  { id: 'calendar', name: 'Ancestry Calendar', holidayGroup: 'standardProducts' },
  { id: 'family-flip', name: 'Family Flip', holidayGroup: 'standardProducts' },
  { id: 'poster', name: 'Ancestry Poster', holidayGroup: 'posters' },
];

/**
 * Order-by dates for the season `today` falls in, earliest standard date first.
 * Returns null outside the season window or for a year without configured dates.
 */
export const christmasDeadlines = (today) => {
  const year = holidaySeasonYear(today);
  if (!year) return null;

  const rows = DEADLINE_PRODUCTS.map((product) => ({
    ...product,
    standard: holidayOrderBy(product, 'standard', year),
    express: holidayOrderBy(product, 'express', year),
  })).sort((a, b) => a.standard - b.standard);

  return { year, rows, book: rows.find((row) => row.id === 'book') };
};

// Dates are UTC calendar days (see shippingSchedule), so format them in UTC.
export const formatDate = (date, options) =>
  date.toLocaleDateString('en-US', { ...options, timeZone: 'UTC' });
